import React, { useState, useEffect } from 'react';
import { Input, Button, Table, message, Card } from 'antd';
import axios from 'axios';
import { BASE_URL } from '../../middleware/api';

const UploadOriginalImagesPage = () => {
  const [folder, setFolder] = useState('');
  const [subFolder, setSubFolder] = useState('');
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  // Завантаження історії процесів при монтуванні
  useEffect(() => {
    loadImageUploadProcesses();
  }, []);

  // GET запит для отримання історії завантажень
  const loadImageUploadProcesses = async () => {
    setTableLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/image-upload`);

      if (response.data && response.data.content) {
        const transformedData = response.data.content.map((item, index) => ({
          key: index,
          folder: item.folder,
          subFolder: item.subfolder || '-',
          initiatedAt: new Date(item.initiatedAt).toLocaleString(),
          initiatorEmail: item.initiatorEmail,
          processed: item.processed ? 'Yes' : 'No'
        }));
        setTableData(transformedData);
      }
    } catch (error) {
      console.error('Failed to load image upload processes:', error);
      message.error('Failed to load upload history');
    } finally {
      setTableLoading(false);
    }
  };

  // POST запит для завантаження зображень
  const handleUploadImages = async () => {
    if (!folder.trim()) {
      message.warning('Please enter a folder path');
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        folder: folder.trim(),
        ...(subFolder.trim() && { subFolder: subFolder.trim() })
      };

      const response = await axios.post(
        `${BASE_URL}/image-upload`,
        requestBody
      );

      if (response.status === 200) {
        message.success('Image upload process initiated successfully');
        // Очищаємо форму
        setFolder('');
        setSubFolder('');
        // Перезавантажуємо історію
        await loadImageUploadProcesses();
      }
    } catch (error) {
      console.error('Failed to upload images:', error);
      message.error('Failed to initiate image upload. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Folder',
      dataIndex: 'folder',
      key: 'folder',
      width: 200
    },
    {
      title: 'Subfolder / Agency',
      dataIndex: 'subFolder',
      key: 'subFolder',
      width: 180
    },
    {
      title: 'Initiated At',
      dataIndex: 'initiatedAt',
      key: 'initiatedAt',
      width: 180
    },
    {
      title: 'Initiator Email',
      dataIndex: 'initiatorEmail',
      key: 'initiatorEmail',
      width: 200
    },
    {
      title: 'Processed',
      dataIndex: 'processed',
      key: 'processed',
      width: 120
    }
  ];

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Card title='Upload Original Images' style={{ marginBottom: '24px' }}>
        <div style={{ marginBottom: '16px' }}>
          <label
            htmlFor='folderInput'
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '500'
            }}
          >
            Folder:
          </label>
          <Input
            id='folderInput'
            value={folder}
            onChange={(e) => setFolder(e.target.value)}
            placeholder='Enter folder path'
            size='large'
            style={{ marginBottom: '16px' }}
          />
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label
            htmlFor='subFolderInput'
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '500'
            }}
          >
            Subfolder / Agency:
            <span
              style={{ color: '#999', fontWeight: 'normal', marginLeft: '8px' }}
            >
              (optional)
            </span>
          </label>
          <Input
            id='subFolderInput'
            value={subFolder}
            onChange={(e) => setSubFolder(e.target.value)}
            placeholder='Enter subfolder or agency name'
            size='large'
          />
        </div>

        <Button
          type='primary'
          size='large'
          onClick={handleUploadImages}
          loading={loading}
          block
          style={{ maxWidth: '300px', margin: '0 auto', display: 'block' }}
        >
          Upload images
        </Button>
      </Card>

      <Card title='Upload History'>
        <Table
          columns={columns}
          dataSource={tableData}
          loading={tableLoading}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            pageSizeOptions: ['10', '20', '50']
          }}
          scroll={{ x: 800 }}
          size='middle'
          bordered
        />
      </Card>
    </div>
  );
};

export default UploadOriginalImagesPage;
